<template>
    <div>
        <div class="header pb-8 pt-2 pt-lg-6 d-flex align-items-center">
            <!-- Mask -->

            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">

                <div class="col-lg-7 p-3 col-md-10">
                    <h2 class="mb-1 ">Prístup odmietnutý</h2>
                    <p class="text-muted">Na prístup k tejto stránke nemáte oprávnenie</p>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'denied',

        data() {
            return {
                colorsto: JSON.parse(localStorage.colors),
            }
        },
        methods: {
        },
        mounted() {
        }
    };
</script>
